import { useQuery } from 'react-query';

import { Profile, fetchProfileSettings } from '../utils/backend-api/profileSettings';

export const PROFILE_SETTINGS_KEY = 'PROFILE_SETTINGS';

export default function useProfile() {
  const { data: profile, isLoading: isLoadingProfile } = useQuery<Profile>(
    PROFILE_SETTINGS_KEY,
    async () => await fetchProfileSettings()
  );
  return { profile, isLoadingProfile };
}
